import { render } from "./AdminDepartments.vue?vue&type=template&id=8bf3f7a8&scoped=true"
import script from "./admindepartments.view.js?vue&type=script&lang=js&external"
export * from "./admindepartments.view.js?vue&type=script&lang=js&external"

import "./admindepartments.css?vue&type=style&index=0&id=8bf3f7a8&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bf3f7a8"]])

export default __exports__